import axiosInstance from './axiosConfig';


// Regional level unit consumption record getting here
export const unitsConsumption = async ({ formattedEnd , formattedStart, level, selectedIds }) => {
  const { productId = [], categoryId = [] } = selectedIds;
  const productIdsStr = productId.join(',');
  const categoryIdsStr = categoryId.join(',');

  const response = await axiosInstance.get(`/regional_level_sales/units_consumption?filter=${level}&start_date=${formattedStart}&end_date=${formattedEnd}&product_ids=${productIdsStr}&category_ids=${categoryIdsStr}`);
  return response.data;
};

// Regional level cost distribution record getting here
export const coastDistribution = async ({ formattedEnd , formattedStart, level, selectedIds }) => {
  const { productId = [], categoryId = [] } = selectedIds;
  const productIdsStr = productId.join(',');
  const categoryIdsStr = categoryId.join(',');
  
  const response = await axiosInstance.get(`/regional_level_sales/coast_distribution?filter=${level}&start_date=${formattedStart}&end_date=${formattedEnd}&product_ids=${productIdsStr}&category_ids=${categoryIdsStr}`);
  return response.data;
};

// Regional level sales record getting here
export const regionalLevelSales = async ({ formattedEnd, formattedStart, level, selectedIds }) => {
  const { productId = [], categoryId = [] , parentProductId = [] } = selectedIds;

  const productIdsStr = productId.join(',');
  const categoryIdsStr = categoryId.join(',');
  const parentProductIdStr = parentProductId.join(',');
  
  const viewType = localStorage.getItem("viewType");

  //  Build query params dynamically
  let url = `/regional_level_sales?filter=${level}&start_date=${formattedStart}&end_date=${formattedEnd}&category_ids=${categoryIdsStr}&parent_product_id=${parentProductIdStr}`;

  if (viewType === "variation" || viewType === "product") {
    url += `&product_wise=${viewType}`;
  }

  const response = await axiosInstance.get(url);
  return response.data;
};


export const locationWiseData = async (queryParams) => {
  const response = await axiosInstance.get(`filter_wise_products/more_detail?${queryParams.toString()}`);
  return response;
};